// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__ueXVG","total":"Cart_total__hyqgr","actions":"Cart_actions__1b0MS","button--alt":"Cart_button--alt__S2lxE","button":"Cart_button__ZXzce"};